<template>
  <div class="file-item" :class="itemInfo.status">
    <div class="preview" :style="{backgroundImage: `url(${itemInfo.preview || ''})`}">
    </div>
    <div class="name">
      <div class="img-name">
        <div>{{itemInfo.name}} </div>
        <div v-if="itemInfo.status === 'fail'">上传失败</div>
      </div>
      <div class="size">{{(itemInfo.size / 1024 / 1024).toFixed(2)}}M</div>
    </div>
    <div class="edit">
      <div class="reload-wrap" @click="handleReUpload">
        重新上传
      </div>
      <div class="delete" @click="remove">删除</div>
    </div>
  </div>
</template>

<script>
import VueTypes from 'vue-types'
// import eventService from '../../../../service/event.service'

export default {
  props: {
    itemInfo: VueTypes.object.def({})
  },
  data () {
    return {
      uploadFile: null,
      formData: null
    }
  },
  methods: {
    handleReUpload () {
      this.$emit('reUpload', this.itemInfo)
    },
    remove () {
      this.$emit('remove', this.itemInfo)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../assets/css/_common";
.file-item {
  position: relative;
  box-sizing: border-box;
  display: flex; align-items: center;
  padding: 12px;
  margin-bottom: 10px;
  height: 64px;
  border: 1px solid rgba(226, 226, 226, .6);
  border-radius: 4px;
  background: #FFF;
  overflow: hidden;

  @include isMobile {
    padding: 8px;
  }

  &:before {
    content: '';
    position: absolute; left: -100%; top: 0;
    width: 100%; height: 100%;
    background: #EEF4FE;
  }

  &.uploading {
    &:before {
      animation: uploading .2s forwards;
    }
  }

  &.success {
    &:before {
      left: -50%;
      animation: success .5s .5s forwards,
      end .5s 2s forwards;
    }
  }

  &.fail {
    border-color: #FFC5BD;
    & .img-name {
      color: #F92A0E;
    }
    &:before {
      animation: fail 0s forwards;
    }
  }

  & .preview {
    flex: none;
    position: relative; z-index: 2;
    margin-right: 12px;
    width: 40px; height: 40px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;

    & img {
      width: 100%;
    }
  }

  & .name {
    position: relative; z-index: 2;
    flex: 1;
    color: $lightBlack;
    @extend %row;

    & .size {
      margin-top: 5px;
      color: $gray;
      @include lineFont(12, 400);
      @include isMobile {
        margin-top: 2px;
      }
    }
    & .img-name {
      display: flex;
      @include lineFont(14, 400);
      @extend %row;

      @include isMobile {
        flex-direction: column;
        line-height: 15px;
        @include font(12, 400);
      }

      & div {
        @extend %row;
      }
    }
  }

  & .edit {
    flex: none;
    display: flex; align-items: center; justify-content: flex-end;
    position: relative; z-index: 2;
    padding-right: 20px;
    width: 150px;
    @include font(14, 400);
    color: $gray;

    @include isMobile {
      padding-right: 10px;
      width: 120px;
      font-size: 13px;
    }

    & .delete {
      cursor: pointer;

      &:hover {
        color: #F92A0E;
      }
    }

    & .reload-wrap {
      position: relative;
      margin-right: 20px;
      cursor: pointer;

      &:hover {
        color: $blue;
      }

      @include isMobile {
        margin-right: 10px;
      }
      & .file-input {
        position: relative; z-index: 2;
      }
    }
  }
}

@keyframes uploading {
  to {
    left: -50%;
  }
}
@keyframes success {
  from {
    left: -50%;
  }
  to {
    left: 0;
  }
}
@keyframes end {
  to {
    opacity: 0;
  }
}
@keyframes fail {
  to {
    left: 0;
    background: #FFC5BD;
    opacity: .6;
  }
}
</style>
